import { useEffect, useRef, useState } from 'react'

const DISPLAY_MS = 5000
const TRANSITION_MS = 300

export type AnimationPhase = 'idle' | 'out' | 'in'

export function useAnimatedBadges(count: number): { rotationIndex: number; animationPhase: AnimationPhase } {
  const [rotationIndex, setRotationIndex] = useState(0)
  const [animationPhase, setAnimationPhase] = useState<AnimationPhase>('idle')
  const timersRef = useRef<number[]>([])

  useEffect(() => {
    timersRef.current.forEach((timerId) => window.clearTimeout(timerId))
    timersRef.current = []
    setRotationIndex(0)
    setAnimationPhase('idle')

    if (count <= 1) {
      return
    }

    const scheduleNext = () => {
      const displayTimer = window.setTimeout(() => {
        setAnimationPhase('out')
        const swapTimer = window.setTimeout(() => {
          setRotationIndex((current) => (current + 1) % count)
          setAnimationPhase('in')
          const endTimer = window.setTimeout(() => {
            setAnimationPhase('idle')
            scheduleNext()
          }, TRANSITION_MS)
          timersRef.current.push(endTimer)
        }, TRANSITION_MS)
        timersRef.current.push(swapTimer)
      }, DISPLAY_MS)
      timersRef.current.push(displayTimer)
    }

    scheduleNext()

    return () => {
      timersRef.current.forEach((timerId) => window.clearTimeout(timerId))
      timersRef.current = []
    }
  }, [count])

  return { rotationIndex, animationPhase }
}
